import { keyValueViewModel } from "../common-model/common.model";

export const COMMON_CONSTANTS = {
  PAGE_OPTIONS_LIST: [
    { id: 5, value: '5 Per Page' },
    { id: 10, value: '10 Per Page' },
    { id: 25, value: '25 Per Page' },
    { id: 50, value: '50 Per Page' },
    { id: 100, value: '100 Per Page' }
  ],
  PAGE_OPTIONS_LIST_LG: [
    { id: 5, value: '5 Per Page' },
    { id: 10, value: '10 Per Page' },
    { id: 25, value: '25 Per Page' },
    { id: 50, value: '50 Per Page' },
    { id: 100, value: '100 Per Page' },
    { id: 150, value: '150 Per Page' },
    { id: 200, value: '200 Per Page' }
  ],
  PASSWORDREGX: "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$",
  GRID_HIGH_LIGHT_COLOR: "#0d8df3",
  NA_TEXT: "N.A.",
  INCREMENTAL_SEARCH_CHAR_LENTH: 3,
  TOAST_TIME_MILLSECONDS_OUT: 10000,
  YES_TEXT: "Yes",
  NO_TEXT: "No",
  MASK_NUMBER_ONLY: "[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]",
  EMAIL_REGEX: "^([a-zA-Z0-9][\\w.\\-+]*?)@([\\w\\-]+)((\\.(\\w){2,3})+)$",
  FILTER_PAG_REGEX: "/[^0-9]/g",
  EXCEED_HOUR: 'EXCEED_HOUR'
};
export const ROLE_CONSTANTS = {
  ADMIN: "ADMIN",
  CITY_MANAGER: "CITY_MANAGER",
  LEAD_MAN: "LEAD_MAN",
  ASSISTANT_CITY_MANAGER: "ASSISTANT_CITY_MANAGER",
  ACCOUNT_SUPERVISOR: "ACCOUNT_SUPERVISOR",
  ACCOUNT_MANAGER: "ACCOUNT_MANAGER",
  ACCOUNT_EXECUTIVE: "ACCOUNT_EXECUTIVE",
  CLIENT: "CLIENT",
  PAYROLL_FINANCE: "PAYROLL_FINANCE",
  ESTIMATOR: "ESTIMATOR",
  ACCOUNTING: "ACCOUNTING",
  ACCOUNT_COORDINATOR: "ACCOUNT_COORDINATOR",
  USER_ROLE_DL: "USER_ROLE_DL",
  SUB_CONTRACTOR: "SUB_CONTRACTOR",
  REGIONAL_CITY_MANAGER: "REGIONAL_CITY_MANAGER",
  LEADERSHIP_SALES: "LEADERSHIP_SALES",
  LEADERSHIP_OPERATIONS: "LEADERSHIP_OPERATIONS",
  LEADERSHIP_ACCOUNTING: "LEADERSHIP_ACCOUNTING",
};
export const SO_HOLD_REASON_CONSTANTS = {
  WAITING_ON_PO: "Waiting On PO",
  RESEARCH: "Research",
  OTHER: "Other"
};
export const SIDEBAR_MENU_VISIBILITY_CHECK_CONSTANTS = {
  WEEKLY_MEET: "WEEKLY_MEET",
};
export const SEND_TO_CLIENT_MODE_CONSTANTS = {
  MANUAL: "MANUAL",
  DIRECT_EMAIL: "DIRECT_EMAIL",
  MANUAL_DISPLAY: "Manual",
  DIRECTL_EMAIL_DISPLAY: "Direct Email",
};
export const MESSAGE_CATEGORY_CONSTATNS = {
  ERROR: "ERROR",
  WARNING: "WARNING",
  INFO: "INFO",
  SUCCESS: "SUCCESS",
  USER_LOGIN: "User Login",
  USER_ADD: "Add User",
  USER_UPDATE: "Update User",
  USER_DELETE: "Delete User",
  USER_PROFILE: "Profile User",
  USER: "User",
  USER_LIST: "User List",
  RESET_PASSWORD: "Reset Password",
  WEEKLY_MEETING: "Weekly Meeting",
  STATE_ADD: "Add State",
  STATE: "State",
  STATE_UPDATE: "State Update",
  CITY_ADD: "City Add",
  CITY_UPDATE: "City Update",
  MATERIAL_ADD: "Material Add",
  MATERIAL: "Material",
  EQUIPMENT: "Equipment",
  MATERIAL_UPDATE: "Material Update",
  MATERIAL_UNIT_ADD: "Material Unit Add",
  GENERAL_CITY_ADD: "General City Add",
  GENERAL_CITY: "General City",
  GENERAL_CITY_UPDATE: "General City Update",
  MATERIALL_UNIT_UPDATE: "Material Unit Update",
  UNAUTHORIZEd_ACCESS: "Un-authorized access",
  VENUE_ADD: "Venue Add",
  VENUE: "Venue",
  VENUE_UPDATE: "Venue Update",
  CITY_MANAGE: "Manage City",
  SYSTEM_ROLE: "System Role",
  CLIENT_CONTACT_ROLE: "Client Contact Role",
  CLIENT_CONTACT_ROLE_ADD: "Client Contact Role Add",
  CLIENT_CONTACT_ROLE_UPDATE: "Client Contact Role Update",
  CLIENT: "Client",
  CLIENT_ADD: "Client Add",
  CLIENT_UPDATE: "Client Update",
  LABOR_ADD: "Add Labor",
  LABOR_UPDATE: "Update Labor",
  TRADE_SHOW_ADD: "Show Add",
  TRADE_SHOW_UPDATE: "Show Update",
  TRADE_SHOW_FILE_DOWNLOAD: "Show File Download",
  TRADE_SHOW_FILE_DELETE: "Show File Delete",
  LABOR: "Labor",
  LABOR_TAX_RULES_WAGES: "Labor Tax Rules Wages",
  CLIENT_RATE_CARD: "Client Rate Card",
  FORGOT_PASSWORD: "Forgot Password",
  LANDING_PAGE: "Landing Page",
  HOLIDAY_ADD: "Holiday Add",
  HOLIDAY_UPDATE: "Holiday Update",
  HOLIDAY_CLONE: "Holiday Clone",
  SERVICE_ORDER_ADD: "Service Order Add",
  SERVICE_ORDER: "Service Order",
  HOLIDAY_LIST: "Holiday List",
  JOB_PLANNING: "Job Planning",
  OVERRUN: "Overrun",
  JOB_LABOR_CHECK_IN: "Check-In",
  JOB_LABOR_DAILY_ACTIVITY: "Daily Activity",
  JOB_PAYROLL_ENTRY: "Payroll Entry",
  JOB_BILLING_ENTRY: "Billing Entry",
  MANUAL_PAYROLL_ENTRY: "MANUAL_PAYROLL_ENTRY",
  MANUAL_PAYROLL_ENTRY_ADD_UPDATE: "MANUAL_PAYROLL_ENTRY_ADD_UPDATE",
  APPLICATION_UPDATE: "Application Update",
  ACCOUNTING: "Accounting",
  ACCOUNT_COORDINATOR: "Account Coordinator",
  ACCOUNT_MANAGER: "Account Manager",
  PLATINUM_INSTRUCTION_TEMPLATE: "Platinum Instruction Template",
  PLATINUM_INSTRUCTION: "Platinum Instruction",
  ACCOUNT_SUPERVISOR: "Account Supervisor",
  ACCOUNT_EXECUTIVE: "Account Executive",
  LEADERSHIP_SALES: "Leadership Sales",
  LEADERSHIP_OPERATION: "Leadership Operation",
  REPORT: "Report",
  FOLLOW_UP: "Follow-up",
  SHOW_JOB_CENTRAL: "Central",
  LABOR_AVAILABILITY_SMS: "Labor Availability Confirmation",
  EMAIL_VIEWER: "Email Viewer",
  REPORT_LINK: "Report Link",
};
export const MESSAGE_CONSTATNS = {
  COMMON_ERROR_MESSAGE: "Invalid operation, please try again.",
  INVALID_OPTION: "Invalid option, please try again.",
  FILE_DOWNLOAD_ISSUE: "Could not download the file, please try again.",
  FILE_DELETE_ISSUE: "Could not delete the file, please try again.",
  DEPARTMENT_SELECT: "Please select a Department.",
  BASE_CITY_SELECT: "Please select a Base City.",
  ROLE_SELECT: "Please select a Role.",
  ROLE_SELECT_DEFAULT: "Please select a default Role.",
  LUNCH_TIME_SELECT: "Please select Lunch Time.",
  NO_OTHER_ROLE_ASSIGNMENT: "For Sub-Contractor, no other Role allocation is allowed.",
  SELECT_REMOVE_SELECTED_ROLES: "To add Sub-Contractor Role, please remove the existing Role allocated already.",
  SELECT_MATERIAL_UNIT: "Please select a Material Unit.",
  MATERIAL_UNIT_NAME_EXIST: "Material Unit name already exists.",
  MATERIAL_NAME_EXIST: "Material Name exists already.",
  GENERAL_CITY_NAME_EXIST: "General City name already exists.",
  CITY_NAME_EXIST: "City Name exists already.",
  STATE_NAME_EXIST: "State Name exists already.",
  STATE_SHORT_NAME_EXIST: "State Short Name already exists.",
  USER_NAME_EXIST: "User Name already exists.",
  USER_FIRST_LAST_NAME_EXIST: "User First and Last name combination exist already.",
  LOGIN_TO_CONTINUE: "Please login to continue",
  VENUE_NAME_EXIST: "Venue name already exists .",
  VENUE_SELECT: "Please select vanue.",
  SELECT_CITY_MANAGER: "Please select city manager.",
  SELECT_CITY: "Please select City.",
  SELECT_DEFAULT_CITY: "Please select default City.",
  SELECT_EXHIBITOR: "Please select Exhibitor.",
  SELECT_EXHIBIT_HOUSE: "Please select Exhibit House.",
  CLIENT_CONTACT_ROLE_SELECT: "Please select Client Contact Role.",
  CLIENT_CONTACT_ROLE_NAME_EXIST: "Role name already exist.",
  ONLY_ONE_CITY_MANAGER_SELECT: "Only one City Manager Role can be allocated to a User.",
  ONLY_THREE_ADDRESS: "Only 3 addresses are allowed.",
  REQUIRED_FIELD_VALIDATION: "Please fill required details.",
  EMAIL_EXIST: "Email already exists.",
  TRADE_SHOW_TYPE_SELECT: "Please select Show Type",
  TRADE_FEE_TYPE_SELECT: "Please select Fee Type",
  TRADE_SHOW_STATE_SELECT: "Please select Show State",
  TRADE_SHOW_CITY_SELECT: "Please select Show City",
  TRADE_SHOW_FILE_DELETE_SUCCESS: "Show file deleted successfuly",
  SELECT_DAY: "Please select a day.",
  SELECT_YEAR: "Please select a year.",
  RATE_CARD_NAME_EXIST: "Rate Card Name already exists.",
  SELECT_FILE: "Please select a file.",
  START_DATE_NOT_EXCEED_THE_END_DATE: "The start date should not exceed the end date.",
  DISABLE_POPUP_BLOCKER: "Please disable your pop-up blocker",
  SAMPLE_PDF: "Sample PDF downloaded successfully.",
  SELECT_IMAGE: "Please select a image.",
  IMAGE_LENTH_100: "Image name should not be greater than 100 char.",
  HOLIDAY_CLONE_SUCCESS: "Holiday cloned successfully.",
  SELECT_MATERIAL: "Please select Material.",
  SELECT_EQUIPMENT: "Please select Equipment.",
  SELECT_COUNTRY: "Please select Country.",
  SELECT_STATE: "Please select State.",
  START_END_DATE_SAME: "The start and end date should not be same.",
  REMOVE_SHIPMENT: "Please remove one shipment.",
  FILE_NAME_EXCEED: "File name should not be greater than 90 character.",
  ACCESS_NOT_AVAIALABLE: "Access not available.",
  SELECT_MMI_TEAM: "MMI Team Information is required.",
  UNSAVE_CHANGES: "Click Continue to finish editing. Click Back and edits will not be saved.",
  SELECT_RED_FLAG: "Please select red flag.",
  SO_UPDATE_NOT_ALLOWED: "Service Order update operation is not allowed now.",
  SELECT_RATE_CARD: "Please select a Rate Card.",
  SELECT_CONTACT: "Please select a Contact.",
  NOTE_REQUIRED: "Please add a note.",
  ST_OT_DT_RATE_REQUIRED: "ST, OT, DT rate required.",
  ST_RATE_REQUIRED: "ST rate required.",
  OT_RATE_REQUIRED: "OT rate required.",
  DT_RATE_REQUIRED: "DT rate required.",
  MATERIAL_RATE_UPDATE_REQUIRED: "Please update material rate.",
  SELECT_SO: "Please select a Service Order.",
  SO_VIEW_PDF: "SO View PDF downloaded successfully.",
  SELECT_SLOT_LABOR_ALLOCATION: "Please select a Slot for Labor Allocation.",
  Move_DATE_NOT_VALID: "Move Date should be within the Show dates.",
  SLOT_CONFLICT: "There is a conflict occurring while moving this Labor slot within the Show - ",
  SLOT_NOT_REQUIRED: "Slot marked as not required.",
  FILE_SIZE_EXCEED: "File size exceeds, the maximum limit is 50mb",
  SELECT_SLOT: "Please select a Slot.",
  SELECT_UNBILL_TYPE: "Please select UnBill Type.",
  SELECT_UNBILL_CODE: "Please select UnBill Code.",
  SELECT_DATE: "Please select Date.",
  SELECT_EAC_FORM: "Please select EAC Form.",
  SELECT_OVERRUN_REASON: "Please select Overrun Reason.",
  SO_BILL_FOR_REQUIRED: "General Info - Bill for required.",
  NAME_REQUIRED: "Name is required.",
  LABOR_ALLOCATED_ALREADY: "Labor already allocated to this slot.",
  SELECT_ONE: "Select at least one record.",
  PAYROLL_ENTRY_NOT_SAVE: "Please save Payroll Entry before submit.",
  START_TIME_NOT_GREATER_THAN_END_TIME: "The start time should not exceed the end time.",
  SELECT_MONTH: "Please select Month.",
  SELECT_START_END_DATE: "Please select Start and End Date.",
  SO_SELECT_CONTACT: "Please select a Contact for SO ",
  SELECT_SHOW_DATE: "Please select Show Date",
  SELECT_INSTALL_DATE: "Please select Install Date",
  SELECT_DISM_DATE: "Please select Dismantle Date",
  SELECT_SHOW: "Please select Show",
  SELECT_ACCOUNT_MANAGER: "Please select Account Manager",
  SELECT_ACCOUNT_EXECUTIVE: "Please select Account Executive",
  ADD_COMMENT: "Please add a comment",
  SUPERVISON_CAP_AMOUNT: "Supervision amount should not be greater than $",
  NO_Change_In_DATE: "No Change in dates.",
  INSTALL_START_DATE_NOT_GREATER_SHOW_START_DATE: "Install start date should not be greater than show start date.",
  SHOW_START_DATE_NOT_GREATER_DISM_END_DATE: "Show start date should not be greater than dismantle end date.",
  INSTALL_START_DATE_NOT_GREATER_INSTALL_END_DATE: "Install start date should not be greater than install end date.",
  INSTALL_END_DATE_NOT_GREATER_DISM_START_DATE: "Install end date should not be greater than dismantle start date.",
  DISM_START_DATE_NOT_GREATER_DISM_END_DATE: "Dismantle start date should not be greater than dismantle end date.",
  SHOW_END_DATE_NOT_GREATER_DISM_END_DATE: "Show end date should not be greater than dismantle end date.",
  ADD_EMAIL_BODY: "Please add a email body.",
  ADD_EMAIL_SUBJECT: "Please add a email subject.",
  SELECT_DATE_IF_ALL_CITY_SELECTED: "Please select a date, if all option is selected for city.",
  SELECT_ESTIMATE_OR_STRAIGHT_ORDER: "Please select a estimate or straight order details.",
  TRAVEL_LEAD_COST_REQ: "Travel Lead cost is required.",
  SO_NUMBER_REQUIRED: "Service Order number is required.",
  PAYROLL_CORRECTION_COMMENT_ADD: "Please provide Payroll Correction comment, which is mandatory for past week Payroll Corrections.",
  SELECT_CLIENT: "Please select Client.",
  HOURS_REQUIRED: "Please provide valid hours value.",
  SELECT_EMAIL_TO_CONTACT: "At least one contact must be marked as Email TO.",
  QUANTITY_CANNOT_BE_ZERO: "Quantity cannot be zero.",
  MATERIAL_NAME_REQUIRED: "Material Name is required.",
  MATERIAL_RATE_CANNOT_BE_ZERO: "Material Rate cannot be zero.",
  EQUIPMENT_RATE_CANNOT_BE_ZERO: "Equipment Rate cannot be zero.",
  LABOR_DATE_NOT_VALID: "Please select valid Labor Date.",
  LABOR_DATE_REQUIRED: "Labor date is required.",
  DATA_NOT_AVAILABLE: "Data is not available.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_REPORT_LOAD_ERROR: "Unable to load 90-60-30 follow-up report. Please try again.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_ROW_SELECTION_EH_MISMATCH: "All selected rows must belong to the same Exhibit House. Deselect first to switch.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_ROW_SELECTION_MULTI_EX_EXIST: "Filtered results contain multiple Exhibit Houses. Filter by a single EH first, or select rows individually.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_EMAIL_NO_SOS_SELECTED: "No SOs available to send. Please check at least one SO in Common, Partial, or Unmatched sections.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_EMAIL_SENT_SUCCESS: "Follow-up email sent successfully.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_EMAIL_SENT_FAILED: "Failed to send follow-up email.'",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_EMAIL_UNABLE_SENT: "Unable to send follow-up email. Please try again.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_EDIT_STATUS_NO_SELECTION: "Please select at least one status.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_EDIT_STATUS_NO_GO_SUBSTATUS_REQUIRED: "Please select a No Go Status.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_EDIT_STATUS_NO_GO_NOTE_REQUIRED: "Please add a note for No Go.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_EDIT_STATUS_UPDATE_SUCCESS: "Follow-up status updated successfully.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_EDIT_STATUS_UPDATE_FAILED: "Failed to update follow-up status.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_EDIT_STATUS_UNABLE_UPDATE: "Unable to save follow-up status. Please try again.",
  ACCOUNT_MANAGER_FOLLOW_UP_90_60_30_PDF_EXPORT_UPGRADE: "PDF export is being upgraded. Please use Excel export for now.",
  CORS_ERROR: "CORS validation failed.",
};
export const DATE_FORMAT_CONSTATNS = {
  MM_DD_YYYY: "mm-dd-yyyy",
  YYYY_MM_DD_HH_MM_AM_PM: "yyyy-MM-dd hh:mm a",
  YYYY_MM_DD: "yyyy-MM-dd",
  YYYY_MM_DD_ddd: "yyyy-MM-dd . EEE",
  YYYY_MM_DD_MOMENT: "YYYY-MM-DD",
  DAY_NAME_MONTH_DAY_YEAR_AM_PM: "EE, MMM d, y h:mm a",///Mon, Jun 15, 2015, 9:03 AM
  DAY_NAME_MONTH_DAY_YEAR: "EE, MMM dd, y",///Mon, Jun 15, 2015,
  DAY_NAME_DATE: "EE, dd",///Mon, 15,
  HH_MM: "hh:mm",
  MM_YYYY: "MM/yyyy",
};
export const COUNTRY_CONSTATNS = {
  US: "US"
};
export const COUNTRY_ISO_CONSTATNS = {
  US: "US",
  CANADA: "CA"
};
export const FILTER_CONSTANTS = {
  ALL: "All",
};
export const CITY_TYPES_CONSTANTS = {
  BASE_CITY_KEY: "BASE_CITY",
  BASE_CITY_DISPLAY_NAME: "Base City",
  TIER_2_CITY: "TIER_2_CITY",
  TIER_2_CITY_DISPLAY_NAME: "Tier 2 City",
  BASE_CITY_SUBCONTRACTOR_KEY: "BASE_CITY",
  BASE_CITY_SUBCONTRACTOR_DISPLAY_NAME: "Sub-Contractor City",
};
export const CITY_LUNCH_TIME_CONSTANTS = {
  NO_LUNCH_TIME_KEY: 0,
  NO_LUNCH_TIME_DISPLAY_NAME: "No Lunch",
  HALF_HOUR_LUNCH_TIME_KEY: 0.5,
  HALF_HOUR_LUNCH_TIME_DISPLAY_NAME: "0.5 Hour",
  ONE_HOUR_LUNCH_TIME_KEY: 1,
  ONE_HOUR_LUNCH_TIME_DISPLAY_NAME: "1 Hour"
};
export const MODULE_CONSTANTS = {
  MANAGE_CITY: "MANAGE_CITY",
  DASHBOARD: "DASHBOARD",
  STATE_MANAGEMENT: "STATE_MANAGEMENT",
  MATERIAL_MANAGEMENT: "MATERIAL_MANAGEMENT",
  GENERAL_CITY_MANAGEMENT: "GENERAL_CITY_MANAGEMENT",
  REPORT: "REPORT",
  VENUE_MANAGEMENT: "VENUE_MANAGEMENT",
  USER_MANAGEMENT: "USER_MANAGEMENT",
  CITY_MANAGEMENT: "CITY_MANAGEMENT",
  SYSTEM_ROLE: "SYSTEM_ROLE",
  CLIENT_CONTACT_ROLE: "CLIENT_CONTACT_ROLE",
  CLIENT_MANAGEMENT: "CLIENT_MANAGEMENT",
  LABOR_MANAGEMENT: "LABOR_MANAGEMENT",
  LABOR_TAX_RULE_WAGES_MANAGEMENT: "LABOR_TAX_RULE_WAGES_MANAGEMENT",
  CLIENT_RATE_CARD: "CLIENT_RATE_CARD",
  LANDING_PAGE_CUSTOMIZATION: "LANDING_PAGE_CUSTOMIZATION",
  COMMON: "COMMON",
  TRADE_SHOW: "TRADE_SHOW",
  HOLIDAY_MANAGEMENT: "HOLIDAY_MANAGEMENT",
  SERVICE_ORDER: "SERVICE_ORDER",
  JOB_LABOR_PLANNING: "JOB_LABOR_PLANNING",
  //PAYROLL_BILLING_REPORT: "PAYROLL_BILLING_REPORT",
  APPLICATION_UPDATE: "APPLICATION_UPDATE",
  ACCOUNTING_DEPOSIT_INVOICE_REPORT: "ACCOUNTING_DEPOSIT_INVOICE_REPORT",
  ACCOUNTING_PAYROLL_BILLED_HRS_REPORT: "ACCOUNTING_PAYROLL_BILLED_HRS_REPORT",
  PLATINUM_REPORT: "PLATINUM_REPORT",
  ESTIMATE_FOLLOW_UP_REPORT: "ESTIMATE_FOLLOW_UP_REPORT",
  FOLLOW_UP_90_60_30_REPORT: "FOLLOW_UP_90_60_30_REPORT",
  PLATINUM_INSTRUCTION_TEMPLATE: "PLATINUM_INSTRUCTION_TEMPLATE",
  PLATINUM_INSTRUCTION_DUE: "PLATINUM_INSTRUCTION_DUE",
  DAILY_ACTIVITY: "DAILY_ACTIVITY",
  MONITORING_PROGRESS: "MONITORING_PROGRESS",
  CURRENT_ORDER_REPORT: "CURRENT_ORDER_REPORT",
  CURRENT_ESTIMATE_REPORT: "CURRENT_ESTIMATE_REPORT",
  FULL_SCHEDULE_REPORT: "FULL_SCHEDULE_REPORT",
  AUDIT_REPORT: "AUDIT_REPORT",
  JOB_UPDATE_REPORT: "JOB_UPDATE_REPORT",
  CITY_HOURS_REPORT: "CITY_HOURS_REPORT",
  RANKING_REPORT: "RANKING_REPORT",
  SHOW_SPECIFIC_REPORT: "SHOW_SPECIFIC_REPORT",
  JOB_PERFORMANCE_REPORT: "JOB_PERFORMANCE_REPORT",
  SHOW_COMPARISON_REPORT: "SHOW_COMPARISON_REPORT",
  BILLING_ENTRY_ADD_UPDATE: "BILLING_ENTRY_ADD_UPDATE",
  PAYROLL_ENTRY_ADD_UPDATE: "PAYROLL_ENTRY_ADD_UPDATE",
  PAYROLL_ENTRY_REPORT: "PAYROLL_ENTRY_REPORT",
  MANUAL_PAYROLL_ENTRY: "MANUAL_PAYROLL_ENTRY",
  PAYROLL_ENTRY_SNAPSHOT: "PAYROLL_ENTRY_SNAPSHOT",
  BILLING_ENTRY_REPORT: "BILLING_ENTRY_REPORT",
  SHOW_CENTRAL: "SHOW_CENTRAL",
  JOB_CENTRAL: "JOB_CENTRAL",
  CLIENT_FACING_TIMESHEET: "CLIENT_FACING_TIMESHEET",
  PAYROLL_LABOR_HOURS: "PAYROLL_LABOR_HOURS",
  TRAVEL_LEAD_REPORT: "TRAVEL_LEAD_REPORT",
  LEADERSHIP_OP_OVERRUN_JOB_VIEW: "LEADERSHIP_OP_OVERRUN_JOB_VIEW",
  LEADERSHIP_OP_ESTIMATION_REVENUE_INFORMATION: "LEADERSHIP_OP_ESTIMATION_REVENUE_INFORMATION",
  LEADERSHIP_OP_DASHBOARD: "LEADERSHIP_OP_DASHBOARD",
  LEADERSHIP_SALES_DASHBOARD: "LEADERSHIP_SALES_DASHBOARD",
  ACCOUNTING_DASHBOARD: "ACCOUNTING_DASHBOARD",
  EMAIL_LIST: "EMAIL_LIST",
  EMAIL_QUICKBOOK: "EMAIL_QUICKBOOK",
  DAILY_ACTIVITY_MATERIAL: "DAILY_ACTIVITY_MATERIAL",
  DAILY_ACTIVITY_EQUIPMENT: "DAILY_ACTIVITY_EQUIPMENT",
  DAILY_ACTIVITY_TIMESHEET: "DAILY_ACTIVITY_TIMESHEET",
  ESTIMATOR_SO_SEARCH: "ESTIMATOR_SO_SEARCH",
  BUDGET_COMPARISON: "BUDGET_COMPARISON",
  PHOTO_GALLERY: "PHOTO_GALLERY"
};
export const MODULE_GROUP_CONSTANTS = {
  DASHBOARD: "DASHBOARD",
  ADMIN: "ADMIN",
  REPORT: "REPORT",
  COMMON: "COMMON",
  SERVICE_ORDER: "SERVICE_ORDER",
  CITY_MANAGER: "CITY_MANAGER",
  ACCOUNTING: "ACCOUNTING",
  ACCOUNT_MANAGER: "ACCOUNT_MANAGER",
  ACCOUNT_SUPERVISOR: "ACCOUNT_SUPERVISOR",
  ACCOUNT_EXECUTIVE: "ACCOUNT_EXECUTIVE",
  SHOW_JOB_CENTRAL: "SHOW_JOB_CENTRAL",
  LEADERSHIP_OPERATION: "LEADERSHIP_OPERATION",
  LEADERSHIP_SALES: "LEADERSHIP_SALES",
  EMAIL_VIEWER: "EMAIL_VIEWER",
};
export const CLIENT_TYPE_CONSTANTS = {
  EXHIBITORS: "EXHIBITORS",
  EXHIBIT_HOUSE: "EXHIBIT_HOUSE",
  EXHIBITORS_DISPLAY_NAME: "Exhibitor",
  EXHIBIT_HOUSE_DISPLAY_NAME: "Exhibit House",
  EXHIBITORS_DISPLAY_SHORT_NAME: "E",
  EXHIBIT_HOUSE_DISPLAY_SHORT_NAME: "EH",
};
export const ACCOUNT_TYPE_CONSTANTS = {
  PLATINUM_DISPLAY_NAME: "Platinum",
  DIAMOND_DISPLAY_NAME: "Diamond",
  CRITICAL_DISPLAY_NAME: "Focus",
  PLATINUM: "PLATINUM",
  DIAMOND: "DIAMOND",
  CRITICAL: "CRITICAL",
  STANDARD: "STANDARD",
  STANDARD_DISPLAY_NAME: "Standard",
};
export const CLIENT_MANAGE_INSTRUCTIONS_CONSTANTS = {
  SPECIAL_INSTRUCTION: "SPECIAL_INSTRUCTION",
  CRITICAL_INSTRUCTIONS: "CRITICAL_INSTRUCTIONS",
  DIAMOND_INSTRUCTIONS: "DIAMOND_INSTRUCTIONS",
  SPECIAL_INSTRUCTION_DISPLAY_NAME: "Special Instructions",
  CRITICAL_INSTRUCTIONS_DISPLAY_NAME: "Critical Instructions",
  DIAMOND_INSTRUCTIONS_DISPLAY_NAME: "Diamond Instructions",
  ALL: "All"
};
export const ORDER_STATUS_CONSTANTS = {
  ORDER_STATUS_ESTIMATE: "ESTIMATE",
  ORDER_STATUS_ORDER: "ORDER",
  ORDER_STATUS_ESTIMATE_DISPLAY: "Estimate",
  ORDER_STATUS_ORDER_DISPLAY: "Order",
};
export const SERVICE_TYPE_STATUS_CONSTANTS = {
  SERVICE_TYPE_INSTALL: "INSTALL",
  SERVICE_TYPE_DISMANTLE: "DISMANTLE",
  SERVICE_TYPE_INSTALL_DISMANTLE: "INSTALL_DISMANTLE",
  SERVICE_TYPE_INSTALL_DISPLAY: "Install",
  SERVICE_TYPE_DISMANTLE_DISPLAY: "Dismantle",
  SERVICE_TYPE_INSTALL_DISMANTLE_DISPLAY: "Install & Dismantle",
};
export const ADDRESS_CATEGORY_CONSTANTS = {
  BILL_TO: "BILL_TO",
  SHIP_TO: "SHIP_TO",
  OTHER: "OTHER",
  BILL_TO_DISPLAY_NAME: "Bill To",
  SHIP_TO_DISPLAY_NAME: "Ship To",
  OTHER_DISPLAY_NAME: "Other"

};
export const LABOR_CATEGORY_CONSTATNS = {
  A: "A",
  B: "B",
  C: "C",
  AP: "AP",
  ALL: "ALL",
};
export const TRADE_SHOW_CONSTATNS = {
  DEFAULT_SHOW_TYPE_KEY: "TRADE_SHOW",
  DEFAULT_SHOW_INDUSTRY_KEY: "TRADE_SHOW",
  PRIVATE_EVENT: "PRIVATE_EVENT",
  TRADE_SHOW: "TRADE_SHOW",
  OTHERS: "OTHERS",
  PERMANENT_INSTALL_DISMANTLE: "PERMANENT_INSTALL_DISMANTLE",

};
export const TRADE_SHOW_FILE_CATEGORY = {
  QUICK_FACTS: "QUICK_FACTS",
  FLOOR_PLAN: "FLOOR_PLAN",
  CERTIFICATE_OF_INSURANCE: "CERTIFICATE_OF_INSURANCE",
  BLANK_EAC_FORM: "BLANK_EAC_FORM"
};
export const MODE_CONSTATNS = {
  UPDATE: "update",
  CLONE: "clone",
};
export const APP_CONSTANTS = {
  APP_TITLE: "MMI Safe Web 2.0",
  APP_NAME: "MMI Safe Web"
};
export const EAC_FEES_TYPE_CONSTANTS = {
  PER_SHOW: 'PER_SHOW',
  PER_JOB: 'PER_JOB',
  PER_SQFT: 'PER_SQFT',
  PER_SHOW_SQFT: 'PER_SHOW_SQFT',
  PER_JOB_SQFT: 'PER_JOB_SQFT',

  PER_SHOW_DISPLAY_NAME: 'Per Show',
  PER_JOB_DISPLAY_NAME: 'Per Job',
  PER_SQFT_DISPLAY_NAME: 'Per Sq.Ft.',
  PER_SHOW_SQFT_DISPLAY_NAME: 'Per Show + Sq.Ft.',
  PER_JOB_SQFT_DISPLAY_NAME: 'Per Job + Sq.Ft.',
};
export const BOOTH_ELEMENT_CONSTANTS = {
  FURNITURE_DISPLAY: "Furniture",
  AUDIO_VISUAL_DISPLAY: "Electrical / Audio Visual",
  FLOORING_DISPLAY: "Flooring",
  HANGING_SIGN_DISPLAY: "Hanging Sign",

  FURNITURE_KEY: "FURNITURE",
  AUDIO_VISUAL_KEY: "AUDIO_VISUAL",
  FLOORING_KEY: "FLOORING",
  HANGING_SIGN_KEY: "HANGING_SIGN"
};

export const BOOTH_FIELD_FILES_CONSTANTS = { //Please do not change key constant, you can change display name only.
  //Main Category Start
  SHOW_INFORMATION_FILE_GROUP_CATEGORY_DISPLAY: "Show Information Files",
  BOOTH_SETUP_VISUALS_GROU_CATEGORYP_DISPLAY: "Booth setup visuals",
  GENERAL_CONTRACTOR_SHOW_ORDERS_GROUP_CATEGORY_DISPLAY: "General Contractor Show Orders",
  PACKING_GROUP_CATEGORY_DISPLAY: "Packing",
  PLATINUM_INSTRUCTION_GROUP_CATEGORY_DISPLAY: "Platinum Instructions",

  SHOW_INFORMATION_FILE_GROUP_CATEGORY_KEY: "SHOW_INFORMATION_FILE",
  BOOTH_SETUP_VISUALS_GROUP_CATEGORY_KEY: "BOOTH_SETUP_VISUALS",
  GENERAL_CONTRACTOR_SHOW_ORDERS_GROUP_CATEGORY_KEY: "GENERAL_CONTRACTOR_SHOW_ORDERS",
  PACKING_GROUP_CATEGORY_KEY: "PACKING",
  PLATINUM_INSTRUCTION_GROUP_CATEGORY_KEY: "PLATINUM_INSTRUCTION",
  //Main Category End

  //Sub Category Start
  //CONSOLIDATED_SHOW_INFO_DOC_CATEGORY_DISPLAY_NAME: "Consolidated Show Info Documents ",
  RENDERING_CATEGORY_DISPLAY_NAME: "Renderings",
  DRAWING_OR_PRINTS_CATEGORY_DISPLAY_NAME: "Drawings or Prints (CAD)",
  CURRENT_PHOTOS_CATEGORY_DISPLAY_NAME: "Current Photos",
  JOB_LABOR_PACKET_CATEGORY_DISPLAY_NAME: "Job Labor Packet",
  FLOORING_CATEGORY_DISPLAY_NAME: "Flooring",
  //CONSOLIDATED_SHOW_SERVICE_DOC_CATEGORY_DISPLAY_NAME: "Consolidated Show Services Document",
  ELECTRICAL_CATEGORY_DISPLAY_NAME: "Electrical",
  FURNITURE_CATEGORY_DISPLAY_NAME: "Furniture",
  HANGING_SIGN_CATEGORY_DISPLAY_NAME: "Hanging Signs",
  INSURANCE_CERTIFICATE_CATEGORY_DISPLAY_NAME: "Insurance Certificate",
  INTERNET_CATEGORY_DISPLAY_NAME: "General/Internal",
  LIGHTING_CATEGORY_DISPLAY_NAME: "Lighting",
  PACKING_CATEGORY_DISPLAY_NAME: "Packing",
  //OUTBOUND_FREIGHT_DOCUMENT_CATEGORY_DISPLAY_NAME: "Outbound Freight Documents",
  PLATINUM_INSTRUCTION_CATEGORY_DISPLAY_NAME: "Platinum Instructions",
  ELECTRICAL_LAYOUT_CATEGORY_DISPLAY_NAME: "Electrical Layout",

  CONSOLIDATED_SHOW_INFO_DOC_CATEGORY_KEY: "CONSOLIDATED_SHOW_INFO_DOCUMENT",
  RENDERING_CATEGORY_KEY: "RENDERING",
  DRAWING_OR_PRINTS_CATEGORY_KEY: "DRAWING_OR_PRINTS",
  CURRENT_PHOTOS_CATEGORY_KEY: "CURRENT_PHOTOS",
  JOB_LABOR_PACKET_CATEGORY_KEY: "JOB_LABOR_PACKET",
  FLOORING_CATEGORY_KEY: "FLOORING",
  //CONSOLIDATED_SHOW_SERVICE_DOC_CATEGORY_KEY: "CONSOLIDATED_SHOW_SERVICE_DOCUMENT",
  ELECTRICAL_CATEGORY_KEY: "ELECTRICAL",
  FURNITURE_CATEGORY_KEY: "FURNITURE",
  HANGING_SIGN_CATEGORY_KEY: "HANGING_SIGN",
  INSURANCE_CERTIFICATE_CATEGORY_KEY: "INSURANCE_CERTIFICATE",
  INTERNET_CATEGORY_KEY: "GENERAL_INTERNAL",
  LIGHTING_CATEGORY_KEY: "LIGHTING",
  PACKING_CATEGORY_KEY: "PACKING",
  ELECTRICAL_LAYOUT_CATEGORY_KEY: "ELECTRICAL_LAYOUT",

  //INBOUND_FREIGHT_DOCUMENT_CATEGORY_KEY: "INBOUND_FREIGHT_DOCUMENT",
  //OUTBOUND_FREIGHT_DOCUMENT_CATEGORY_KEY: "OUTBOUND_FREIGHT_DOCUMENT",
  PLATINUM_INSTRUCTION_CATEGORY_KEY: "PLATINUM_INSTRUCTION",
  //Sub Category End
};

export const SO_STATUS_CONSTANTS = {
  REQUEST_TYPE_ESTIMATE: "ESTIMATE",
  REQUEST_TYPE_ORDER: "ORDER",
  REQUEST_TYPE_ESTIMATE_DISPLAY: "Estimate",
  REQUEST_TYPE_ORDER_DISPLAY: "Order",

  STATUS_STRAIGHT_ORDER_DISPLAY: "Straight Order",
  STATUS_STRAIGHT_ORDER_KEY: "STRAIGHT_ORDER",

  STATUS_WON_DISPLAY_NAME: "Won",
  STATUS_LOST_DISPLAY_NAME: "Lost",
  STATUS_CANCELED_DISPLAY_NAME: "Cancelled",
  STATUS_OPEN_DISPLAY_NAME: "Open",
  STATUS_CLOSED_DISPLAY_NAME: "Closed",
  STATUS_WON_KEY: "WON",
  STATUS_LOST_KEY: "LOST",
  STATUS_CANCELED_KEY: "CANCELED",
  STATUS_UNWIN_KEY: "UN-WIN",
  STATUS_UNWIN_DISPLAY: "Un-Win",
  STATUS_OPEN_KEY: "OPEN",
  STATUS_CLOSED_KEY: "CLOSED",

  INITIATE_KEY: "INITIATE",
  INITIATE_DISPLAY: "Initiate",
  SENT_FOR_APPROVAL_KEY: "SENT_FOR_APPROVAL",
  SENT_FOR_APPROVAL_DISPLAY: "Sent for Approval",
  APPROVED_KEY: "APPROVED",
  APPROVED_DISPLAY: "Approved",
  NOT_APPROVED_KEY: "NOT_APPROVED",
  NOT_APPROVED_DISPLAY: "Not Approved",
  SENT_BACK_BY_CLIENT_KEY: "SENT_BACK_BY_CLIENT",
  SENT_BACK_BY_CLIENT_DISPLAY: "Sent back by Client",
  ESTIMATION_REVIEW: "ESTIMATION_REVIEW",
  ESTIMATION_COMPLETED: "ESTIMATION_COMPLETED",
  ESTIMATION_SENT_BACK: "ESTIMATION_SENT_BACK",
};
export const RED_FLAG_CATEGORY = {
  MUST_HAVE: "MUST_HAVE",
  GOOD_TO_HAVE: "GOOD_TO_HAVE",
};
export const RED_FLAG_SO_STATUS_CATEGORY = {
  INITIATE: "INITIATE",
  SCOPE: "SCOPE",
  PREPARE: "PREPARE",
  CUSTOM: "CUSTOM",
};

export const RATE_TYPE_COST_CONSTANTS = {
  ST: "ST",
  OT: "OT",
  DT: "DT",
};

export const SO_ACTION_PERMISSION_CONSTANTS = {
  CREATE: "CREATE",
  SETUP_UPDATE: "SETUP_UPDATE",
  WON: "WON",
  LOST: "LOST",
  CANCEL: "CANCEL",
  CREATE_NEW_VERSION: "CREATE_NEW_VERSION",
  PULL_OLD_DATA: "PULL_OLD_DATA",
  CHAT: "CHAT",
  GENERAL_FILE_REPOSITORY: "GENERAL_FILE_REPOSITORY",
  SEND_TO_CLIENT_FOR_APPROVAL: "SEND_TO_CLIENT_FOR_APPROVAL",
  SEND_JOB_TO_CITY_MANAGER: "SEND_JOB_TO_CITY_MANAGER",
  SEND_REMINDER_TO_CLIENT: "SEND_REMINDER_TO_CLIENT",
  REC_REMINDER_CONFIRMATION: "REC_REMINDER_CONFIRMATION",
  UPDATE_CM_LAYOUT: "UPDATE_CM_LAYOUT",
  SEND_JOB_TO_CITY_MANAGER_AGAIN: "SEND_JOB_TO_CITY_MANAGER_AGAIN",
  SEND_SO_VIEW_TO_CLIENT: "SEND_SO_VIEW_TO_CLIENT"
};
export const PAYROLL_BILLING_STATUS_CONSTANTS = {
  PAYROLL_REVIEWED: "PAYROLL_REVIEWED",
  PAYROLL_SUBMITTED: "PAYROLL_SUBMITTED",
  PAYROLL_SAVE: "PAYROLL_SAVE",
  BILLING_REVIEWED: "BILLING_REVIEWED",
  BILLING_SUBMITTED: "BILLING_SUBMITTED",
  BILLING_SAVE: "BILLING_SAVE",
  ACCOUNTING_INVOICED: "ACCOUNTING_INVOICED",
  ACCOUNTING_REVIEWED: "ACCOUNTING_REVIEWED",
  ACCOUNTING_PAYROLL_COMPLETE: "ACCOUNTING_PAYROLL_COMPLETE",

};
export const UNBILL_HRS_TYPE_CONSTANTS = {
  TRAVEL_TIME_KEY: "TRAVEL_TIME",
  TRAVEL_TIME_DISPLAY: "Travel time",

  EQUIPMENT_TIME_KEY: "EQUIPMENT_TIME",
  EQUIPMENT_TIME_DISPLAY: "Equipment time",

  SHOW_TIME_KEY: "SHOW_TIME",
  SHOW_TIME_DISPLAY: "Show time",

  LABOR_ERROR_KEY: "LABOR_ERROR",
  LABOR_ERROR_DISPLAY: "Labor error"

};
export const UNBILL_HRS_CODE_CONSTANTS = {
  NON_DEDUCTIBLE_TIME_KEY: "NON_DEDUCTIBLE_TIME",
  NON_DEDUCTIBLE_TIME_DISPLAY: "Non-deductible time",

  DEDUCTIBLE_TIME_KEY: "DEDUCTIBLE_TIME",
  DEDUCTIBLE_TIME_DISPLAY: "Deductible time",

};

export const OVERRUN_JOB_REASON_CONSTANTS = {
  CUSTOMER_REQUIREMENT_ACCOMMODATED_DISPLAY: "Customer Request Accommodated",
  FREIGHT_ISSUES_DISPLAY: "Freight issues",
  ELECTRIC_ISSUES_DISPLAY: "Electric issues",
  HANGING_SIGN_ISSUE_DISPLAY: "Hanging sign issues",
  ESTIMATE_ISSUE_DISPLAY: "Estimate issue",
  POOR_LABOR_DISPLAY: "Poor labor",

  CUSTOMER_REQUIREMENT_ACCOMMODATED_KEY: "CUSTOMER_REQUEST_ACCOMMODATED",
  FREIGHT_ISSUES_KEY: "FREIGHT_ISSUES",
  ELECTRIC_ISSUES_KEY: "ELECTRIC_ISSUES",
  HANGING_SIGN_ISSUE_KEY: "HANGING_SIGN_ISSUE",
  ESTIMATE_ISSUE_KEY: "ESTIMATE_ISSUE",
  POOR_LABOR_KEY: "POOR_LABOR",
};
export const DAILY_ACTIVITY_TAB_CONSTATNS = {
  INSTALL: "INSTALL",
  DISM: "DISM",
  JW: "JW",
  SHOW: "SHOW",
  MATERIAL: "MATERIAL",
  EQUIPMENT: "EQUIPMENT"
};
export const JOB_TYPE_CONSTANTS = {
  COMPANY: "COMPANY",
  SUB_CONTRACTOR: "SUB_CONTRACTOR",
  HYBRID: "HYBRID",
  SUB_CONTRACTOR_DISPLAY: "Sub Contractor",
  HYBRID_DISPLAY: "Hybrid",
  HYBRID_AND_SUBCONTRACTOR_DISPLAY: "Hybrid and Sub Contractor", // Only for filter purpose
  HYBRID_AND_SUBCONTRACTOR: "HYBRID_SUBCONTRACTOR",// Only for filter purpose
};
export const INST_DISM_SUPERVISION_CONSTANTS = {
  COMPANY: "COMPANY",
  MMI: "MMI",
  EXHIBIT_HOUSE: "EXHIBIT_HOUSE",
  EXHIBITOR: "EXHIBITOR",
};
export const SHOW_COMPARISON_REPORT_CONSTANTS = {
  IN_PROGRESS: "IN_PROGRESS",
  ORDER: "ORDER",
  CREATE_SHOW: "CREATE_SHOW",
  NEW_OPPORTUNITY: "NEW_OPPORTUNITY"
};
export const SO_FILED_FILE_PRINT_DOWNLOAD_CONSTANTS = {
  SO_INBOUND: "SO_INBOUND",
  SO_OUTBOUND: "SO_OUTBOUND",
  SO_BOOTH: "SO_BOOTH",
  SHOW_FILE: "SHOW_FILE",
  SO_VIEW: "SO_VIEW",
};
export const OVER_RUN_STATUS_CONSTANTS = {
  ON_BUDGET_KEY: "ON_BUDGET",
  OVER_BUDGET_KEY: "OVER_BUDGET",
}

export const DAILY_ACTIVITY_CATEGORY_CONSTANTS = {
  ON_BUDGET_CATEGORY_KEY: 'ON_BUDGET',
  END_OF_DAY_CATEGORY_KEY: 'END_OF_DAY'
}

export const DAILY_ACTIVITY_SUB_CATEGORY_CONSTANTS = {
  YES_KEY: 'YES',
  NO_KEY: 'NO'
}
export const CLIENT_SPECIAL_PAY_NOTE_CONSTANTS = {
  GENERAL: 'GENERAL',
  SPECIFIC_EXHIBITOR: 'SPECIFIC_EXHIBITOR',
  BOOTH_SIZE: 'BOOTH_SIZE',
  VENUE: 'VENUE',
  SHOW_NAME_OR_CITY: 'SHOW_NAME_OR_CITY',
  NOTE_CATEGORY_LIST: <keyValueViewModel[]>[
    { key: 'GENERAL', value: 'General' },
    { key: 'BOOTH_SIZE', value: 'Booth Size' },
    { key: 'VENUE', value: 'Venue' },
    { key: 'SHOW_NAME_OR_CITY', value: 'Show Name or City' }
  ]
}
export const EMAIL_TYPE = {
  EMAIL_TYPE_NORMAL_EMAIL: 'NORMAL_EMAIL',
  EMAIL_TYPE_QUICK_BOOK: 'QUICK_BOOK'
}
